// extracted by mini-css-extract-plugin
export default {"additionalReasons":"escalationForm_additionalReasons__uvfrB","checklist_container":"escalationForm_checklist_container__Q+Aa3","checkBoxLabel":"escalationForm_checkBoxLabel__wgGT6"};